<template>
  <!-- <li class="nav-item px-2 text" style="text-align: left"> -->
  <li class="nav-item px-2 text" style="text-align: left">
    <a href="#" class="nav-link">
      <i class="nav-icon fas fa-truck"></i>
      <p>Servicio Integral<i class="fas fa-angle-left right"></i></p>
    </a>
    <ul class="nav nav-treeview">
      <li class="nav-item" v-if="showTarifas">
        <a href="#" class="nav-link">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Tarifas<i class="fas fa-angle-left right"></i></p>
        </a>
        <ul class="nav nav-treeview">
          <li class="nav-item" v-if="showTarifasProveedoresTerrestre">
            <!-- Tarifas Proveedores Terrestres -->
            <router-link
              class="nav-link"
              to="/servicio-integral/tarifas/tarifas_proveedores_terrestres"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Tarifas Prov. Terrestres</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showTarifasProveedoresDocumental">
            <!-- Tarifas Proveedores Documentales -->
            <router-link
              class="nav-link"
              to="/servicio-integral/tarifas/tarifas_proveedores_documentales"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Tarifas Prov. Docum</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showTarifaClienteTerrestre">
            <!-- Tarifa Cliente Terrestre -->
            <router-link
              class="nav-link"
              to="/servicio-integral/tarifas/tarifa_cliente_terrestre"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Tarifa Cliente Terrestre</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showTarifaClienteDocumental">
            <!-- Tarifa Cliente Documental -->
            <router-link
              class="nav-link"
              to="/servicio-integral/tarifas/tarifa_cliente_documental"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Tarifa Cliente Docum.</p>
            </router-link>
          </li>
        </ul>
      </li>
      <li class="nav-item" v-if="showGenerarPropuestaClientes">
        <a href="#" class="nav-link">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>
            Generar Propuesta Cliente<i class="fas fa-angle-left right"></i>
          </p>
        </a>
        <ul class="nav nav-treeview" v-if="showGenerarPropuesta">
          <li class="nav-item">
            <!-- Tarifa Cliente Documental -->
            <router-link
              class="nav-link"
              to="/servicio-integral/generar-propuesta-cliente/generar_propuesta"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Generar Propuesta</p>
            </router-link>
          </li>
        </ul>
      </li>
      <li class="nav-item" v-if="showInstructivosDeEmbarque">
        <a href="#" class="nav-link">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Instructivos de Embarque<i class="fas fa-angle-left right"></i></p>
        </a>
        <ul class="nav nav-treeview">
          <li class="nav-item" v-if="showBookings">
            <!-- Booking -->
            <router-link
              class="nav-link"
              to="/servicio-integral/instructivos-de-embarque/bookings"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Bookings</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showAnadirIE">
            <!-- Añadir I.E. -->
            <router-link
              class="nav-link"
              to="/servicio-integral/instructivos-de-embarque/anadir_i_e"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Añadir I.E.</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showlEPorEnviar">
            <!-- I.E. Por Enviar -->
            <router-link
              class="nav-link"
              to="/servicio-integral/instructivos-de-embarque/i_e_por_enviar"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>I.E. Por Enviar</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showIEEnviadas">
            <!-- I.E. Enviadas -->
            <router-link
              class="nav-link"
              to="/servicio-integral/instructivos-de-embarque/i_e_enviadas"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>I.E. Enviadas</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showIEAceptadas">
            <!-- I.E. Aceptadas -->
            <router-link
              class="nav-link"
              to="/servicio-integral/instructivos-de-embarque/i_e_aceptadas"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>I.E. Aceptadas</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showIERechazadas">
            <!-- I.E. Rechazadas -->
            <router-link
              class="nav-link"
              to="/servicio-integral/instructivos-de-embarque/i_e_rechazadas"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>I.E. Rechazadas</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showTemplate">
            <!-- Template -->
            <router-link
              class="nav-link"
              to="/servicio-integral/instructivos-de-embarque/template"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Template</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showFinalizadas">
            <!-- Finalizadas -->
            <router-link
              class="nav-link"
              to="/servicio-integral/instructivos-de-embarque/finalizadas"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Finalizadas</p>
            </router-link>
          </li>
        </ul>
      </li>
      <li class="nav-item" v-if="showOrdenDeServicio">
        <a href="#" class="nav-link">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Orden de Servicio<i class="fas fa-angle-left right"></i></p>
        </a>
        <ul class="nav nav-treeview">
          <li class="nav-item" v-if="showBuscarOS">
            <!-- Buscar OS -->
            <router-link
              class="nav-link"
              to="/servicio-integral/orden-de-servicio/buscar_os"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Buscar OS</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showPorAsignar">
            <!-- Por Asignar -->
            <router-link
              class="nav-link"
              to="/servicio-integral/orden-de-servicio/por_asignar"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Por Asignar</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showAsignadas">
            <!-- Asignadas -->
            <router-link
              class="nav-link"
              to="/servicio-integral/orden-de-servicio/asignadas"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Asignadas</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showRetiroContenedor">
            <!-- Retiro Contenedor -->
            <router-link
              class="nav-link"
              to="/servicio-integral/orden-de-servicio/retiro_contenedor"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Retiro Contenedor</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showCargoPlantaEntregaMatriz">
            <!-- Carguío en Planta/Entrega Matriz -->
            <router-link
              class="nav-link"
              to="/servicio-integral/orden-de-servicio/c_planta_e_matriz"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Car. Planta / Entrega M.</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showIngresoPuerto">
            <!-- Ingreso Puerto -->
            <router-link
              class="nav-link"
              to="/servicio-integral/orden-de-servicio/ingreso_puerto"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Ingreso Puerto</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showZarpeMasivo">
            <!-- Zarpe Masivo -->
            <router-link
              class="nav-link"
              to="/servicio-integral/orden-de-servicio/zarpe_masivo"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Zarpe Masivo</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showAgregarFactura">
            <!-- Agregar Factura -->
            <router-link
              class="nav-link"
              to="/servicio-integral/orden-de-servicio/agregar_factura"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Agregar Factura</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showDespachoDocumentación">
            <!-- Despacho Documentación -->
            <router-link
              class="nav-link"
              to="/servicio-integral/orden-de-servicio/despacho_documentacion"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Despacho Docum.</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showLegalizacionDUS">
            <!-- Legalización DUS -->
            <router-link
              class="nav-link"
              to="/servicio-integral/orden-de-servicio/legalizacion_dus"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Legalización DUS</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showExtraCostos">
            <!-- Extra Costos -->
            <router-link
              class="nav-link"
              to="/servicio-integral/orden-de-servicio/extra_costos"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Extra Costos</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showPorProcesar">
            <!-- Por Procesar -->
            <router-link
              class="nav-link"
              to="/servicio-integral/orden-de-servicio/por_procesar"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Por Procesar</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showCanceladas">
            <!-- Canceladas -->
            <router-link
              class="nav-link"
              to="/servicio-integral/orden-de-servicio/canceladas"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Canceladas</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="showFinalizadas">
            <!-- Finalizadas -->
            <router-link
              class="nav-link"
              to="/servicio-integral/orden-de-servicio/finalizadas"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Finalizadas</p>
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </li>
</template>

<script>
/**
 * @author Miguel González.
 * @description modify role structure. 
 * last modified 18-04-2023 17:25
 */
  // Vuex
  import { mapState } from "vuex";

  export default {
    data() {
      return {
        showTarifas: false,
        showTarifasProveedoresTerrestre: false,
        showTarifasProveedoresDocumental: false,
        showTarifaClienteTerrestre: false,
        showTarifaClienteDocumental: false,
        showGenerarPropuestaClientes: false,
        showGenerarPropuesta: false,
        showInstructivosDeEmbarque: false,
        showBookings: false,
        showAnadirIE: false,
        showlEPorEnviar: false,
        showIEEnviadas: false,
        showIEAceptadas: false,
        showIERechazadas: false,
        showTemplate: false,
        showFinalizadas: false,
        showOrdenDeServicio: false,
        showBuscarOS: false,
        showPorAsignar: false,
        showAsignadas: false,
        showMisViajes: false,
        showRetiroContenedor: false,
        showCargoPlantaEntregaMatriz: false,
        showIngresoPuerto: false,
        showZarpeMasivo: false,
        showAgregarFactura: false,
        showDespachoDocumentación: false,
        showLegalizacionDUS: false,
        showExtraCostos: false,
        showPorProcesar: false,
        showCanceladas: false,
      };
    },
    computed: {
      ...mapState("modulosLogin", [
        "isServIntegral",
      ])
    },
    methods: {
      superAdmin(){
        this.showTarifas = true;
        this.showTarifasProveedoresTerrestre = true;
        this.showTarifasProveedoresDocumental = true;
        this.showTarifaClienteTerrestre = true;
        this.showTarifaClienteDocumental = true;
        this.showGenerarPropuestaClientes = true;
        this.showGenerarPropuesta = true;
        this.showInstructivosDeEmbarque = true;
        this.showBookings = true;
        this.showAnadirIE = true;
        this.showlEPorEnviar = true;
        this.showIEEnviadas = true;
        this.showIEAceptadas = true;
        this.showIERechazadas = true;
        this.showTemplate = true;
        this.showFinalizadas = true;
        this.showOrdenDeServicio = true;
        this.showBuscarOS = true;
        this.showPorAsignar = true;
        this.showAsignadas = true;
        this.showMisViajes = true;
        this.showRetiroContenedor = true;
        this.showCargoPlantaEntregaMatriz = true;
        this.showIngresoPuerto = true;
        this.showZarpeMasivo = true;
        this.showAgregarFactura = true;
        this.showDespachoDocumentación = true;
        this.showLegalizacionDUS = true;
        this.showExtraCostos = true;
        this.showPorProcesar = true;
        this.showCanceladas = true;
      }
    },
    created(){
      if(JSON.parse(localStorage.getItem('user'))?.rol === 'Super Administrador') this.superAdmin();
      const servIntRoleStructure = JSON.parse(localStorage.getItem('roleStructure')).find(({idModule}) => idModule === 3);
      if(servIntRoleStructure){
        servIntRoleStructure.sections.map(({ idSection, subSections }) => {
          switch (idSection) {
            case 33: //tarifas
              this.showTarifas = true; 
              subSections.map(({ idSubsection }) => {
                switch (idSubsection) {
                  case 70: this.showTarifasProveedoresTerrestre = true; break;
                  case 71: this.showTarifasProveedoresDocumental = true; break;
                  case 72: this.showTarifaClienteTerrestre = true; break;
                  case 73: this.showTarifaClienteDocumental = true; break;
                  default: break;
                }
              });
              break;
            case 34: //generar propuesta clientes
              this.showGenerarPropuestaClientes = true; 
              subSections.map(({ idSubsection }) => {
                switch (idSubsection) {
                  case 241: this.showGenerarPropuesta = true; break;
                  default: break;
                }
              });
              break;
            case 35: //instructivos de embarque
              this.showInstructivosDeEmbarque = true; 
              subSections.map(({ idSubsection }) => {
                switch (idSubsection) {
                  case 74: this.showBookings = true; break;
                  case 75: this.showAnadirIE = true; break;
                  case 76: this.showlEPorEnviar = true; break;
                  case 77: this.showIEEnviadas = true; break;
                  case 78: this.showIEAceptadas = true; break;
                  case 79: this.showIERechazadas = true; break;
                  case 80: this.showTemplate = true; break;
                  case 81: this.showFinalizadas = true; break;
                  default: break;
                }
              });
              break;
            case 36: //order de servicio
              this.showOrdenDeServicio = true;
              subSections.map(({ idSubsection }) => {
                switch (idSubsection) {
                  case 82: this.showBuscarOS = true; break;
                  case 83: this.showPorAsignar = true; break;
                  case 84: this.showAsignadas = true; break;
                  case 242: this.showMisViajes = true; break; //por construir modelo
                  case 85: this.showRetiroContenedor = true; break;
                  case 87: this.showCargoPlantaEntregaMatriz = true; break;
                  case 88: this.showIngresoPuerto = true; break;
                  case 89: this.showZarpeMasivo = true; break;
                  case 86: this.showAgregarFactura = true; break;
                  case 243: this.showDespachoDocumentación = true; break;
                  case 92: this.showLegalizacionDUS = true; break;
                  case 93: this.showExtraCostos = true; break;
                  case 94: this.showPorProcesar = true; break;
                  case 96: this.showFinalizadas = true; break;
                  case 95: this.showCanceladas = true; break;
                  default: break;
                }
              });
              break;
            default: break;
          }
        });
      }

      const servIntUserStructure = JSON.parse(localStorage.getItem('userStructure')).find(({idModule}) => idModule === 3);
      if(servIntUserStructure){
        servIntUserStructure.sections.map(({ idSection, subSections }) => {
          switch (idSection) {
            case 33: //tarifas
              this.showTarifas = true; 
              subSections.map(({ idSubsection }) => {
                switch (idSubsection) {
                  case 70: this.showTarifasProveedoresTerrestre = true; break;
                  case 71: this.showTarifasProveedoresDocumental = true; break;
                  case 72: this.showTarifaClienteTerrestre = true; break;
                  case 73: this.showTarifaClienteDocumental = true; break;
                  default: break;
                }
              });
              break;
            case 34: //generar propuesta clientes
              this.showGenerarPropuestaClientes = true; 
              subSections.map(({ idSubsection }) => {
                switch (idSubsection) {
                  case 241: this.showGenerarPropuesta = true; break;
                  default: break;
                }
              });
              break;
            case 35: //instructivos de embarque
              this.showInstructivosDeEmbarque = true; 
              subSections.map(({ idSubsection }) => {
                switch (idSubsection) {
                  case 74: this.showBookings = true; break;
                  case 75: this.showAnadirIE = true; break;
                  case 76: this.showlEPorEnviar = true; break;
                  case 77: this.showIEEnviadas = true; break;
                  case 78: this.showIEAceptadas = true; break;
                  case 79: this.showIERechazadas = true; break;
                  case 80: this.showTemplate = true; break;
                  case 81: this.showFinalizadas = true; break;
                  default: break;
                }
              });
              break;
            case 36: //order de servicio
              this.showOrdenDeServicio = true;
              subSections.map(({ idSubsection }) => {
                switch (idSubsection) {
                  case 82: this.showBuscarOS = true; break;
                  case 83: this.showPorAsignar = true; break;
                  case 84: this.showAsignadas = true; break;
                  case 242: this.showMisViajes = true; break; //por construir modelo
                  case 85: this.showRetiroContenedor = true; break;
                  case 87: this.showCargoPlantaEntregaMatriz = true; break;
                  case 88: this.showIngresoPuerto = true; break;
                  case 89: this.showZarpeMasivo = true; break;
                  case 86: this.showAgregarFactura = true; break;
                  case 243: this.showDespachoDocumentación = true; break;
                  case 92: this.showLegalizacionDUS = true; break;
                  case 93: this.showExtraCostos = true; break;
                  case 94: this.showPorProcesar = true; break;
                  case 96: this.showFinalizadas = true; break;
                  case 95: this.showCanceladas = true; break;
                  default: break;
                }
              });
              break;
            default: break;
          }
        });
      }
    }
  };
</script>

<style></style>
